const region = document.createElement("div");
region.setAttribute("aria-live", "polite");
region.setAttribute("role", "status");
region.className = "visually-hidden";
document.body.appendChild(region);

let pendingTimeout: ReturnType<typeof setTimeout> | undefined;

/**
 * Announces a message to screen readers via a shared aria-live region.
 * Debounces so only the last message in a burst is announced, and
 * delays delivery to avoid being suppressed during focus transitions.
 */
export function announce(message: string): void {
  clearTimeout(pendingTimeout);
  region.textContent = "";
  pendingTimeout = setTimeout(() => {
    region.textContent = message;
  }, 500);
}
